// logger.ts
import * as Sentry from '@sentry/react';
import { MissionControlEventLogger } from './MissionControlEventLogger';

// Create and initialize the singleton immediately
const logger = new MissionControlEventLogger();

logger.initialize().catch((error) => {
  console.error(`Logger: Failed to initialize singleton`, error);
  Sentry.captureException(error, {
    tags: { component: 'MissionControlEventLogger', action: 'singleton_initialize' },
  });
});

export default logger;
